module.exports = __webpack_public_path__ + "img/M751.ca729ab0.jpg";